module.exports = __webpack_public_path__ + "img/bgreg.242f16de.webp";